import Vue from 'vue';
import VeLine from 'v-charts/lib/line.common';
import VeHistogram from 'v-charts/lib/histogram.common';
import 'v-charts/lib/style.css';

Vue.component(VeLine.name, VeLine);
Vue.component(VeHistogram.name, VeHistogram);
